module.exports = __webpack_public_path__ + "img/placeholder.4d279681.jpg";